export default __webpack_public_path__ + "static/media/call.14ca8736.svg";